import { cn } from '../../lib/utils';
import { Badge } from '../ui/badge';

export type UnreadBadgeVariant = 'floating' | 'inline';

export interface UnreadBadgeProps {
  count: number | undefined | null;
  variant?: UnreadBadgeVariant;
  /** Override badge background colour.
   *  Pass any Tailwind bg-* utility or arbitrary class. Default: brand purple (#6C09F7). */
  toneClassName?: string;
  className?: string;
}

export function UnreadBadge({
  count,
  variant = 'inline',
  toneClassName = 'bg-[var(--brand-500)]',
  className,
}: UnreadBadgeProps) {
  const n = typeof count === 'number' ? count : 0;
  if (n <= 0) return null;

  const display = n > 99 ? '99+' : String(n);
  const isWide = display.length > 1;

  return (
    <Badge
      role="status"
      aria-label={`${n} unread message${n === 1 ? '' : 's'}`}
      className={cn(
        // Override all Badge defaults
        'pointer-events-none select-none items-center justify-center border-0 font-semibold leading-none tabular-nums text-white',
        // Height + shape
        'h-[18px]',
        isWide ? 'min-w-[20px] rounded-full px-[5px]' : 'w-[18px] rounded-full',
        // Font size — legible at 18px height
        'text-[10.5px]',
        // Entrance animation
        'animate-in zoom-in-50 duration-150',
        // Tone
        toneClassName,
        // Floating variant — anchors to relatively-positioned parent
        variant === 'floating' &&
          'absolute -right-1.5 -top-1.5 ring-2 ring-white',
        className,
      )}
    >
      {display}
    </Badge>
  );
}
